import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static values = {
        publishableKey: String,
        clientSecret: String,
        fullName: String,
        email: String,
        postalCode: String,
        countryCode: String,
    }

    connect() {
        super.connect();
        document.getElementById("add_card_button")?.classList.toggle("hidden");
        this._initStripe();
    }

    _initStripe() {
        const stripe = Stripe(this.publishableKeyValue);
        const elements = stripe.elements({
            clientSecret: this.clientSecretValue,
            appearance: { theme: "stripe", variables: { fontSizeBase: "14px" } },
        });

        const paymentElement = elements.create("payment", {
            wallets: { link: "never" },
            fields: {
                billingDetails: {
                    name: "never",
                    email: "never",
                    address: { postalCode: "never", country: "never" },
                },
            },
        });
        paymentElement.mount("#payment-element");

        document.getElementById("payment-form").addEventListener("submit", async (event) => {
            event.preventDefault();
            const { error, setupIntent } = await stripe.confirmSetup({
                elements,
                redirect: "if_required",
                confirmParams: {
                    payment_method_data: {
                        billing_details: {
                            name: this.fullNameValue,
                            email: this.emailValue,
                            address: {
                                postal_code: this.postalCodeValue,
                                country: this.countryCodeValue,
                            },
                        },
                    },
                },
            });

            if (error) {
                document.querySelector("#error-message").textContent = error.message;
            } else {
                const requestLink = document.getElementById("request");
                const url = new URL(requestLink.href, window.location.origin);
                url.searchParams.set("new_payment_method_id", setupIntent.payment_method);
                requestLink.href = url.toString();
                requestLink.click();
            }
        });
    }
}
